/**
 * @internal
 */
export var TIME_PERIOD_FIELDS = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millis',
];
/**
 * @internal
 */
export var TIME_FLAGS = 16 /* HOUR */ | 32 /* MINUTE */ | 64 /* SECOND */ | 128 /* MILLIS */;
var FIELDMAP = {
    year: 1 /* YEAR */,
    month: 2 /* MONTH */,
    week: 4 /* WEEK */,
    day: 8 /* DAY */,
    hour: 16 /* HOUR */,
    minute: 32 /* MINUTE */,
    second: 64 /* SECOND */,
    millis: 128 /* MILLIS */,
};
/**
 * @internal
 */
export var timePeriodFieldFlags = function (fields) {
    return fields.reduce(function (p, c) {
        p |= FIELDMAP[c];
        return p;
    }, 0);
};
//# sourceMappingURL=interval.js.map